import { getSubjectExpansion } from 'utils/messageMaps'

/**
 * Tworzy mapę przedmiotów: { short: nazwa z Firebase, long: pełna nazwa }
 * Używa SUBJECT_EXPANSIONS z messageMaps dla rozszerzonych nazw
 */
export const getSubjectLabelMap = schoolSubjects =>
  (schoolSubjects || []).reduce((acc, s) => {
    const short = (s.name || '').trim()
    if (short) {
      const long = getSubjectExpansion(short) || short
      const entry = { short, long }
      acc[short] = entry
      if (short.toLowerCase() !== short) acc[short.toLowerCase()] = entry
      if (short.toUpperCase() !== short) acc[short.toUpperCase()] = entry
    }
    return acc
  }, {})
